import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function GuideSection() {
  const [isGuideLoaded, setIsGuideLoaded] = useState(false);
  const { FiPlay } = FiIcons;

  return (
    <motion.section 
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.2, duration: 0.8 }}
      className="relative z-10 px-2 md:px-0"
    >
      <div className="max-w-6xl mx-auto">
        {/* Glow Effects */}
        <div className="absolute -top-40 -left-40 w-96 h-96 bg-glow-purple/20 rounded-full blur-[120px] pointer-events-none hidden md:block"></div>
        <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-glow-cyan/20 rounded-full blur-[120px] pointer-events-none hidden md:block"></div>

        <div className="bg-navy-nav/40 backdrop-blur-3xl rounded-[1.5rem] md:rounded-[2.5rem] p-4 md:p-10 border border-white/10 shadow-2xl relative overflow-hidden group">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-badge"></div>
          
          <div className="mb-8 md:mb-10 flex flex-col md:flex-row md:items-center justify-between gap-6 px-2 md:px-4">
            <div>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2 text-center md:text-left">Interactive Selling Trade Guide</h3>
              <p className="text-text-body text-sm md:text-base text-center md:text-left">Master the fundamental signals and entry strategies in real-time.</p>
            </div>
            <div className="flex justify-center md:justify-end gap-3">
              <span className="px-4 py-1.5 bg-green-500/10 border border-green-500/20 text-green-400 text-[9px] md:text-[10px] font-bold uppercase tracking-widest rounded-full">Status: Active</span>
            </div>
          </div>

          {/* GuideJar Iframe Facade Wrapper */}
          <div 
            style={{
              position: 'relative',
              height: 0,
              width: '100%',
              overflow: 'hidden',
              zIndex: 99999,
              borderRadius: '12px',
              boxSizing: 'border-box',
              paddingBottom: 'calc(46.92532943% + 32px)',
              background: '#050508'
            }}
            className="shadow-2xl border border-white/10 group/embed"
          >
            {!isGuideLoaded ? (
              <div 
                className="absolute inset-0 flex flex-col items-center justify-center bg-navy-deep/80 hover:bg-navy-deep/60 backdrop-blur-sm z-10 cursor-pointer transition-all duration-300" 
                onClick={() => setIsGuideLoaded(true)}
              >
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-gradient-brand flex items-center justify-center shadow-[0_0_30px_rgba(232,75,48,0.4)] group-hover/embed:scale-110 group-hover/embed:shadow-[0_0_40px_rgba(232,75,48,0.6)] transition-all duration-300">
                  <SafeIcon icon={FiPlay} className="text-2xl md:text-3xl text-white ml-2" />
                </div>
                <p className="mt-4 md:mt-6 text-white font-bold tracking-widest uppercase text-[10px] md:text-sm animate-pulse text-center px-4">
                  Tap to Load Interactive Selling Guide
                </p>
              </div>
            ) : (
              <iframe 
                src="https://www.guidejar.com/embed/f4c5d0c8-4915-40f3-9b68-bc37873e0daa?type=1&controls=on" 
                width="100%" 
                height="100%" 
                style={{ position: 'absolute', inset: 0 }} 
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" 
                allowFullScreen 
                frameBorder="0"
                title="ProfitLense Selling Trade Guide"
              ></iframe>
            )}
          </div>

          <div className="mt-8 md:mt-10 flex flex-wrap items-center justify-center gap-x-8 md:gap-x-12 gap-y-4 px-2 md:px-4">
            <div className="flex items-center gap-2 md:gap-3">
              <div className="w-2 md:w-2.5 h-2 md:h-2.5 rounded-full bg-brand-pink shadow-[0_0_10px_rgba(232,54,110,0.5)]"></div>
              <span className="text-[9px] md:text-xs text-text-body font-bold uppercase tracking-widest">Entry Logic</span>
            </div>
            <div className="flex items-center gap-2 md:gap-3">
              <div className="w-2 md:w-2.5 h-2 md:h-2.5 rounded-full bg-brand-secondary shadow-[0_0_10px_rgba(30,144,255,0.5)]"></div>
              <span className="text-[9px] md:text-xs text-text-body font-bold uppercase tracking-widest">Confirmation</span>
            </div>
            <div className="flex items-center gap-2 md:gap-3">
              <div className="w-2 md:w-2.5 h-2 md:h-2.5 rounded-full bg-brand-primary shadow-[0_0_10px_rgba(232,75,48,0.5)]"></div>
              <span className="text-[9px] md:text-xs text-text-body font-bold uppercase tracking-widest">Exit Strategy</span>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
}